import { useState } from 'react';
import useReactRouter from 'use-react-router';
import { createContainer } from 'unstated-next';
import { parse } from 'querystring';

import { Karte, GetKartesRequest, CompleteProcessingRequestInfo, KartesApi, Configuration } from 'openapi';

export default createContainer(() => {

  const [kartes, setKartes] = useState<Karte[]>([]);
  const [total, setTotal] = useState(0);
  const { history } = useReactRouter();

  const clear = () => {
    setTotal(0);
    setKartes([]);
  };

  const load = async (getKartesRequest: GetKartesRequest) => {
    try {
      const response = await new KartesApi(new Configuration({
        basePath: process.env.REACT_APP_API_PATH,
        accessToken: localStorage.getItem('token') as string,
      })).getKartes(getKartesRequest);

      setTotal(response.totalCount);
      setKartes(response.data);
    } catch (err) {
      if (err.status === 401) {
        history.push('/users/login');
      }
    }
  };

  const loadQRData = async (queryString: string) => {
    try {
      var query = parse(queryString);

      if (query.karteNo && query.storeCode && query.buyDate) {
        setKartes([]);

        var karte = {
          karteNo: parseInt(query.karteNo as string),
          storeCode: parseInt(query.storeCode as string),
          buyDate: new Date(query.buyDate as string),
        };

        const { data } = await new KartesApi(new Configuration({
          basePath: process.env.REACT_APP_API_PATH,
          accessToken: localStorage.getItem('token') as string,
        })).getKartes({ ...karte, createdDate: new Date(karte.buyDate) });

        setTotal(data.length);
        setKartes(data);
      }
    } catch (err) {
      if (err.status === 401) {
        history.push('/users/login');
      }
    }
  };

  const completeProcessing = async (completeProcessingRequestInfo: CompleteProcessingRequestInfo) => {
    try {
      const response = await new KartesApi(new Configuration({
        basePath: process.env.REACT_APP_API_PATH,
        accessToken: localStorage.getItem('token') as string,
      })).completeProcessing({ completeProcessingRequestInfo });

      const newKartes = kartes.slice();

      var karte = newKartes.find(karte =>
        karte.id === completeProcessingRequestInfo.id &&
        karte.index === completeProcessingRequestInfo.index &&
        karte.karteNo === completeProcessingRequestInfo.karteNo);

      if (karte) {
        if (!karte.processings) {
          karte.processings = [];
        }

        karte.processings.push(response);
        setKartes(newKartes);
      }
    } catch (err) {
      if (err.status === 401) {
        history.push('/users/login');
        return;
      }

      throw err;
    }
  };

  return { kartes, total, clear, load, loadQRData, completeProcessing };
});
